import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["source", "signal"]
  static values = { url: String }

  connect() {
    this.sourceObserver = new MutationObserver(() => this.sourceConnectionChanged())
    this.sourceObserver.observe(this.sourceTarget, {
      attributes: true,
      attributeFilter: ["connected"]
    })
    this.sourceConnectionChanged()
  }

  disconnect() {
    this.sourceObserver?.disconnect()
    this.abortController?.abort()
    this.wasConnected = false
  }

  signalTargetConnected(signal) {
    const displayedVersion = this.displayedVersion()
    const availableVersion = Number(signal.dataset.seatMapVersion)

    if (availableVersion > displayedVersion) this.catchUp(displayedVersion)
  }

  sourceConnectionChanged() {
    const connected = this.sourceTarget.hasAttribute("connected")

    if (connected && !this.wasConnected) this.catchUp(this.displayedVersion())
    this.wasConnected = connected
  }

  displayedVersion() {
    return Number(this.element.querySelector("[data-seat-map-stream-target='content']")?.dataset.seatMapVersion || 0)
  }

  async catchUp(displayedVersion) {
    this.abortController?.abort()
    this.abortController = new AbortController()

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("seat_map_catch_up", "1")
    url.searchParams.set("seat_map_version", displayedVersion)
    url.searchParams.set("seat_map_modal", this.element.closest("[data-seat-map-modal-body]") ? "1" : "0")

    try {
      const response = await fetch(url, {
        cache: "no-store",
        headers: { Accept: "text/vnd.turbo-stream.html" },
        signal: this.abortController.signal
      })

      if (response.ok && response.status !== 204) {
        Turbo.renderStreamMessage(await response.text())
      }
    } catch (error) {
      if (error.name !== "AbortError") console.warn("Seat map catch-up failed", error)
    }
  }
}
